import React from 'react';
import { useNavigate } from 'react-router-dom';
import './NotFound.css'; // Import the CSS file for styling

const NotFound = () => {
  const navigate = useNavigate()
  return (
    <div className="notfound-container">
      <div className="notfound-content">
        <h1 className="notfound-header">404</h1>
        <h2 className="notfound-subheader">Page Not Found</h2>
        <p className="notfound-description">
          Oops! The page you’re looking for doesn’t exist or has been moved.
        </p>
        <button className="notfound-btn" onClick={() => navigate(-1)}>
          
            Go Back
          
        </button>
      </div>
    </div>
  );
};

export default NotFound;
